import SBEFLabel from '@client/pages/components/SBEFLabel';
import { useSetElementSelectPropertyCount } from '@client/hooks/use-element-properties.hooks';
import { isProductCategoryElement } from '@shared/helpers/element-category.helpers';
import { getSelectPropertyOptions } from '@shared/helpers/element-property.helpers';
import {
  getSbefCodeFromElementOrRecipe,
  getSbefProperty,
} from '@shared/helpers/sbef.helpers';
import { ElementSelectPropertyCountType } from '@shared/models/element-property.model';
import { IElement } from '@shared/models/project.model';
import React, { useCallback, useMemo } from 'react';
import { createPropertySelectOptions } from '@shared/helpers/element-property-factory.helpers';
import { ELEMENT_PROPERTY_SELECT_INHERIT_COUNT } from '@shared/constants/expression-variables.constants';

interface ElementListItemSBEFLabelProps {
  element: IElement;
  hideIfEmpty?: boolean;
}

const ElementListItemSBEFLabel: React.FC<ElementListItemSBEFLabelProps> = ({
  element,
  hideIfEmpty = false,
}) => {
  const selectProperty = useSetElementSelectPropertyCount(element);

  const code = getSbefCodeFromElementOrRecipe(element);
  const property = useMemo(() => getSbefProperty(element), [element]);

  const menuItems = useMemo(
    () =>
      property
        ? [
            ...createPropertySelectOptions([
              ELEMENT_PROPERTY_SELECT_INHERIT_COUNT,
            ]),
            ...getSelectPropertyOptions(property),
          ]
        : [],
    [property],
  );

  const handleSelect = useCallback(
    (value: ElementSelectPropertyCountType) => {
      if (property) {
        selectProperty(value, property);
      }
    },
    [selectProperty, property],
  );

  if (isProductCategoryElement(element) || !property) {
    return null;
  }

  return (
    <SBEFLabel
      code={code}
      menuItems={menuItems}
      hidden={hideIfEmpty && !code}
      onSelect={handleSelect}
    />
  );
};

export default ElementListItemSBEFLabel;
